export default __webpack_public_path__ + "static/media/frame_45_delay-0.05s.7606d5c0.gif";